import UserSettingsService from "src/services/userSettingsService";

import { ColumnId } from "../components/Table/DeviceTable.utils";

export const setColumnVisibility = (columnName: ColumnId) => {
    const currentVisibleColumns = UserSettingsService.getDevicePageVisibleColumns();

    const newVisibilityState = {
        ...currentVisibleColumns,
        [columnName]: true,
    };

    UserSettingsService.setWorkspaceValue("devicePage.visibleColumns", newVisibilityState);
    return newVisibilityState;
};
